import { render, staticRenderFns } from "./FacebookMockup.vue?vue&type=template&id=404cb741&"
import script from "./FacebookMockup.vue?vue&type=script&lang=js&"
export * from "./FacebookMockup.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMockup.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports